import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Home, ArrowLeft } from 'lucide-react';
import aplenLogo from '../images/aplen_logo.png';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <Card className="max-w-md mx-auto border-0 shadow-lg">
        <CardContent className="p-8 text-center">
          <div className="mb-6">
            <img src={aplenLogo} alt="Apken Life Sciences" className="h-36 w-auto mx-auto mb-4 rounded-md" />
            <h1 className="text-7xl font-bold text-primary mb-2">404</h1>
            <div className="w-20 h-1 bg-primary mx-auto rounded-full"></div>
          </div>
          
          <h2 className="text-2xl font-semibold text-foreground mb-3">Page Not Found</h2>
          <p className="text-muted-foreground mb-8 leading-relaxed">
            The page you're looking for doesn't exist or has been moved to another location.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() => navigate('/')}
              className="bg-primary hover:bg-primary/90 text-primary-foreground px-6 py-2"
            >
              <Home className="w-4 h-4 mr-2" />
              Go Home
            </Button>
            
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              className="border-border text-foreground hover:bg-accent hover:text-accent-foreground px-6 py-2"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
